import { render } from "./PopUpAddTrip.vue?vue&type=template&id=674cdaef&scoped=true"
import script from "./PopUpAddTrip.vue?vue&type=script&lang=js"
export * from "./PopUpAddTrip.vue?vue&type=script&lang=js"

import "./PopUpAddTrip.vue?vue&type=style&index=0&id=674cdaef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674cdaef"]])

export default __exports__